module.exports = __webpack_public_path__ + "static/media/logo-pan.34525a57.png";